import { Injectable } from '@angular/core';

@Injectable()
export class MatiereModel {

  constructor() { }
  public id_type_mat:string;
  public lib_matiere:string;
}